import { useField } from 'formik';
import { memo, useEffect } from 'react';

import { Box } from '@mui/material';
import { InterviewAudioDetail, InterviewLanguage } from '@synergetx/puppet-interview-types';

import AudioUploadAccordion from './AudioUploadAccordion';

const GeneralAudioUploadButtons = () => {
    const [{ value: languages }] = useField<InterviewLanguage[]>('languages');
    const [{ value: generalAudio }, , { setValue: setGeneralAudio }] =
        useField<InterviewAudioDetail>('interviewGeneralAudio');

    useEffect(() => {
        if (languages.length > 0 && Object.keys(generalAudio).length < languages.length) {
            const audio: InterviewAudioDetail = Object.fromEntries(
                languages.map((language) => [
                    language,
                    { meToo: '', thatsLikeMe: '', whichOneOfUs: '' },
                ]),
            );
            setGeneralAudio({ ...audio, ...generalAudio });
        }
    }, [generalAudio, languages, setGeneralAudio]);

    return generalAudio && Object.keys(generalAudio || {}).length ? (
        <Box sx={{ ml: 1, width: '100%' }}>
            {languages.map((language) => (
                <AudioUploadAccordion key={language} language={language} />
            ))}
        </Box>
    ) : null;
};

export default memo(GeneralAudioUploadButtons);
